import React from 'react';
import BenefitsCard from '../components/BenefitsCard';
import CallToAction from '../components/CallToAction';
import CallToActionDetails from '../components/CallToActionDetails';
import ContactForm from '../components/ContactForm';
import AdvancedCheckout from '../components/FeatureDetails/AdvancedCheckout';
import CustomerReview from '../components/FeatureDetails/CustomerReview';
import ReduceRto from '../components/FeatureDetails/ReduceRto';
import SingleClickCheckout from '../components/FeatureDetails/SingleClickCheckout';
import UpliftPrepaidOrders from '../components/FeatureDetails/UpliftPrepaidOrders';
import LandingPage from '../components/LandingPage';
import LogoSlider from '../components/LogoSlider';
  
const Home = () => {
  return (
    <>
      <LandingPage />
      <LogoSlider />
      <CallToAction />
      <BenefitsCard />
      <SingleClickCheckout />
      <AdvancedCheckout />
      
      <ReduceRto />
      <CustomerReview />
      <UpliftPrepaidOrders />
      <CallToActionDetails />
      <ContactForm />
    </>
  );
};
  
export default Home;